module.exports = __webpack_public_path__ + "static/img/TBZ.5679203b.jpg";